import { configureStore } from '@reduxjs/toolkit';

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import profileSlice from './slices/profileSlice';
import featureFlagSlice from './slices/featureFlagSlice';
import globalStateSlice from './slices/gloableState';
import subscriptionSlice from './slices/subscriptionSlice';
const store = configureStore({
  reducer: {
    profile: profileSlice,
    featureFlag: featureFlagSlice,
    globalState: globalStateSlice,
    subscription: subscriptionSlice
  }
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
